/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type InviteQueryVariables = {||};
export type InviteQueryResponse = {|
  +whoami: ?{|
    +id: any,
    +username: string,
    +referralCode: ?string,
    +referralLink: ?string,
  |}
|};
export type InviteQuery = {|
  variables: InviteQueryVariables,
  response: InviteQueryResponse,
|};
*/


/*
query InviteQuery {
  whoami {
    id
    username
    referralCode
    referralLink
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "UserType",
    "kind": "LinkedField",
    "name": "whoami",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "username",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "referralCode",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "referralLink",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "InviteQuery",
    "selections": (v0/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "InviteQuery",
    "selections": (v0/*: any*/)
  },
  "params": {
    "cacheID": "c2d0774e72849415b634b8dcf21ba8fb",
    "id": null,
    "metadata": {},
    "name": "InviteQuery",
    "operationKind": "query",
    "text": "query InviteQuery {\n  whoami {\n    id\n    username\n    referralCode\n    referralLink\n  }\n}\n"
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = 'fb90e67622a722be43e16178eb46b94c';

module.exports = node;
